/**
 * Hidden SEO topic pages (Sam, Oct 7 2026: "Rather keep it hidden").
 * Reachable from Google + the sitemap only. Do NOT link these from the Topbar,
 * footer, home, FAQ, How it works, About or Browse. They may link to each other,
 * to Browse (/s) and to signup.
 *
 * Keep in sync with server/api-util/publicSeoPaths.js (topicPages.test.js checks it).
 */
export const TOPIC_PAGE_ROUTES = [
  { id: 'talk-about-anything', path: '/talk-to-someone-about-anything', name: 'TalkAboutAnythingPage' },
  { id: 'vent', path: '/someone-to-vent-to', name: 'SomeoneToVentToPage' },
  { id: 'divorce', path: '/talk-to-someone-about-divorce', name: 'TalkAboutDivorcePage' },
  { id: 'relationships', path: '/talk-to-someone-about-relationships', name: 'TalkAboutRelationshipsPage' },
  { id: 'family', path: '/talk-to-someone-about-family', name: 'TalkAboutFamilyPage' },
  { id: 'money', path: '/talk-to-someone-about-money', name: 'TalkAboutMoneyPage' },
  { id: 'work', path: '/talk-to-someone-about-work', name: 'TalkAboutWorkPage' },
  { id: 'health-worries', path: '/talk-to-someone-about-health-worries', name: 'TalkAboutHealthWorriesPage' },
  { id: 'faith', path: '/talk-to-someone-about-faith', name: 'TalkAboutFaithPage' },
  { id: 'politics', path: '/someone-to-talk-politics-with', name: 'TalkPoliticsPage' },
  { id: 'life-changes', path: '/talk-to-someone-about-life-changes', name: 'TalkAboutLifeChangesPage' },
  { id: 'late-night', path: '/someone-to-talk-to-at-night', name: 'SomeoneToTalkToAtNightPage' },
  { id: 'bored', path: '/someone-to-talk-to-when-bored', name: 'SomeoneToTalkToWhenBoredPage' },
  { id: 'accountability', path: '/online-accountability-partner', name: 'AccountabilityPartnerPage' },
  { id: 'sounding-board', path: '/sounding-board', name: 'SoundingBoardPage' },
  { id: 'get-paid-to-listen', path: '/get-paid-to-listen', name: 'GetPaidToListenPage' },
];

export const TOPIC_PAGE_IDS = TOPIC_PAGE_ROUTES.map(r => r.id);
export const topicRouteById = id => TOPIC_PAGE_ROUTES.find(r => r.id === id) || null;
